import { render, staticRenderFns } from "./NewPaymentsPayoneerCreate.vue?vue&type=template&id=3a2ff2b0&scoped=true"
import script from "./NewPaymentsPayoneerCreate.vue?vue&type=script&lang=js"
export * from "./NewPaymentsPayoneerCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2ff2b0",
  null
  
)

export default component.exports